import { useMutation, useQueryClient } from '@tanstack/react-query';
import { boxInvitationsQuery } from 'networking/mindfeed/queries/boxInvitations';
import { notify, NotificationType } from 'xstate/actors/NotificationActor';
import { updateBoxInvitationRole } from 'networking/mindfeed/services/box.service';
import { BoxId } from 'models/Box';
import { InvitationId, InvitationRole } from 'models/Invitation';

type Variables = {
  boxId: BoxId;
  invitationId: InvitationId;
  role: InvitationRole;
};

const useUpdateBoxInvitationRole = () => {
  const queryClient = useQueryClient();

  const onSuccessCallback = async (_data: void, variables: Variables) => {
    // Invalidate invitations
    queryClient.invalidateQueries({
      queryKey: boxInvitationsQuery(variables.boxId).queryKey,
    });

    // Notify User
    notify(NotificationType.BOX_INVITATION_ROLE_UPDATED);
  };

  return useMutation<void, Error, Variables>({
    mutationFn: (variables) =>
      updateBoxInvitationRole(
        variables.boxId,
        variables.invitationId,
        variables.role,
      ),
    onSuccess: onSuccessCallback,
  });
};

export default useUpdateBoxInvitationRole;
